/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.5.3(793ede49d53dba79d39e52205f16321278f5183c)
 * Released under the MIT license
 * https://github.com/Microsoft/vscode/blob/master/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/base/common/worker/simpleWorker.nls.ru", {
	"vs/base/common/errors": [
		"{0}. Код ошибки: {1}",
		"Отказано в разрешении (HTTP {0})",
		"Отказано в разрешении",
		"{0} (HTTP {1}: {2})",
		"{0} (HTTP {1})",
		"Неизвестная ошибка подключения ({0})",
		"Произошла неизвестная ошибка подключения. Утеряно подключение к Интернету, либо сервер, к которому вы подключены, перешел в автономный режим.",
		"{0}: {1}",
		"Произошла неизвестная ошибка. Подробные сведения см. в журнале.",
		"Произошла системная ошибка ({0})",
		"Произошла неизвестная ошибка. Подробные сведения см. в журнале.",
		"{0} (всего ошибок: {1})",
		"Произошла неизвестная ошибка. Подробные сведения см. в журнале.",
		"Не реализовано",
		"Недопустимый аргумент: {0}",
		"Недопустимый аргумент",
		"Недопустимое состояние: {0}",
		"Недопустимое состояние",
		"Сбой загрузки требуемого файла. Утеряно подключение к Интернету, либо сервер, к которому вы подключены, перешел в автономный режим. Обновите содержимое браузера, чтобы повторить попытку.",
		"Не удалось загрузить требуемый файл. Перезапустите приложение, чтобы повторить попытку. Дополнительные сведения: {0}.",
	],
	"vs/base/common/keyCodes": [
		"Windows",
		"Управление",
		"Shift",
		"Alt",
		"COMMAND",
		"Windows",
		"Ctrl",
		"Shift",
		"Alt",
		"COMMAND",
		"Windows",
	],
	"vs/base/common/severity": [
		"Ошибка",
		"Предупреждение",
		"Сведения",
	]
});